import React from "react";
import { Zap, ArrowRight } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const Login = () => {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ink-900 text-white flex flex-col lg:flex-row">
      {/* Left: brand */}
      <div className="flex-1 flex flex-col justify-between p-8 sm:p-14 relative overflow-hidden">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-xl bg-brand flex items-center justify-center">
            <Zap className="w-6 h-6 text-ink-900" fill="#09090B" />
          </div>
          <span className="font-display text-2xl font-bold">SuperPumped Studio</span>
        </div>

        <div className="max-w-xl animate-fade-up">
          <p className="text-brand font-semibold tracking-wide uppercase text-sm mb-4">Creative Production OS</p>
          <h1 className="font-display text-5xl sm:text-6xl font-bold leading-[1.02] tracking-tight">
            From brief to <span className="text-brand">client approval.</span>
          </h1>
          <p className="text-zinc-400 text-lg mt-6 leading-relaxed">
            The internal workspace for creative agencies that ship high-volume, scroll-stopping ads.
            Assign briefs, track editors, curate batches, and let clients approve — all in one place.
          </p>
        </div>

        <div className="text-zinc-600 text-sm">© {new Date().getFullYear()} SuperPumped Studio. Built for scaling creative teams.</div>
        <div className="pointer-events-none absolute -right-40 -bottom-40 w-[500px] h-[500px] rounded-full bg-brand/10 blur-3xl" />
      </div>

      {/* Right: login card */}
      <div className="flex-1 flex items-center justify-center p-8 border-t lg:border-t-0 lg:border-l border-ink-700 bg-ink-900">
        <div className="w-full max-w-sm">
          <h2 className="font-display text-3xl font-bold mb-2">Welcome back</h2>
          <p className="text-zinc-400 mb-8">Sign in to access your production dashboard.</p>
          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="group w-full h-14 rounded-full bg-brand text-ink-900 font-semibold text-lg flex items-center justify-center gap-3 hover:bg-brand-hover transition-all hover:scale-[1.02]"
          >
            Continue with Google
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          <p className="text-zinc-500 text-sm mt-6 leading-relaxed">
            Team members are assigned roles automatically. Clients see only their own creatives in a private portal.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
